import React, { useEffect, useState } from 'react'
import Input from 'uiKit/inputs/Input'
import { urlValidation } from 'helpers/urlValidation'

import * as S from './WebsiteURLForm.style'
import { EnterArrow } from 'uiKit/icons/EnterArrow'
import { TrainingStatus } from '../../../../settings/constants/trainingStatus'

interface Props {
  trainingStatus: string
  urls: string[]
  onClick: (url: string) => void
}

export const WebsiteURLForm: React.FC<Props> = ({ onClick, urls, trainingStatus }) => {
  const [website, setWebsite] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    const isNotUnique = isOneOfTopLevelPages(website)

    if (isNotUnique) {
      setError('This URL is already added')
    } else {
      setError('')
    }
  }, [urls])

  // Does not check the sub-URLs, sub-URL check is performed by Odin
  const isOneOfTopLevelPages = websiteUrl => urls.some(url => url === websiteUrl)

  const handleChange = e => {
    const isNotUnique = isOneOfTopLevelPages(e.target.value)
    const isValid = urlValidation(e.target.value)

    if (!isValid) {
      setError('Please enter valid URL')
    } else if (isNotUnique) {
      setError('This URL is already added')
    } else {
      setError('')
    }

    setWebsite(e.target.value)
  }

  const handleEnter = () => {
    if (!error && website) {
      onClick(website)
      setWebsite('')
    }
  }

  return (
    <S.Container>
      <S.Title>Website URL</S.Title>
      <S.Form>
        <Input
          placeholder="+Add website URL and press Enter"
          value={website}
          onChange={handleChange}
          error={Boolean(error)}
          errorMessage={error}
          handleEnterPress={handleEnter}
        />
        <S.Icon>
          <EnterArrow />
        </S.Icon>
      </S.Form>
      {trainingStatus === TrainingStatus.PENDING && <S.DisableScreen />}
    </S.Container>
  )
}
